import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { BrainCircuit } from 'lucide-react';
export function MechanismSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="py-24 px-4 bg-teal text-cream relative overflow-hidden" data-id="element-92">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-93">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold rounded-full blur-3xl" data-id="element-94"></div>
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-sage rounded-full blur-3xl" data-id="element-95"></div>
      </div>

      <div ref={ref} className={`max-w-4xl mx-auto relative z-10 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <BrainCircuit className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-98" />
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-gold" data-id="element-99">
            La clave no es "descansar", es la{' '}
            <span className="text-gold" data-id="element-100">Micro-Recuperación Neural</span> (MRN).
          </h2>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-3xl text-lg md:text-xl leading-relaxed font-light" data-id="element-101">
          <p className="mb-6" data-id="element-102">
            Este protocolo no te pide que te vayas a un spa. Te enseña a hackear
            tu nervio vago en ventanas de{' '}
            <strong className="text-gold font-normal" data-id="element-103">180 segundos</strong>.
          </p>
          <p data-id="element-104">
            Mediante intervenciones físicas específicas, le enviamos una señal
            química a tu cerebro para apagar la respuesta de "lucha o huida". Es
            como instalar un freno de mano en un auto que iba sin control cuesta
            abajo.
          </p>
        </div>
      </div>
    </section>;
}